import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FlexBox, Icon, Page } from '@dixa/lib-shared-habla';
import { useParams } from 'react-router-dom';
import { useMount } from 'react-use';
import { AppLink } from 'components/appLink';
import { withTeams } from 'hocs';
import { TeamsAgents } from '../teamsAgents/teamsAgents';
const TeamsDetailsPageImpl = ({ teams, }) => {
    const { id } = useParams();
    useMount(() => {
        if (id) {
            teams.getItem(id);
        }
    });
    const { item } = teams;
    return (_jsxs(Page, { children: [_jsx(Page.Head, { title: _jsxs(FlexBox, Object.assign({ gap: "200", alignItems: "center" }, { children: [_jsx(AppLink, Object.assign({ path: "/settings/teams", style: { color: 'inherit' } }, { children: "Teams" })), _jsx(Icon, { name: "angle-right" }), item === null || item === void 0 ? void 0 : item.name] })) }), _jsx(Page.Body, { children: item && _jsx(TeamsAgents, { teamId: item.id }) })] }));
};
export const TeamsDetailsPage = withTeams(TeamsDetailsPageImpl);
